import { CJEvent, Tag } from './event';

/**
 * @deprecated use NiveauValue from scholarSystem
 */
export enum Niveau {
  TPS = 'TPS',
  PS = 'PS',
  MS = 'MS',
  GS = 'GS',
  CP = 'CP',
  CE1 = 'CE1',
  CE2 = 'CE2',
  CM1 = 'CM1',
  CM2 = 'CM2',
  '6e' = '6e',
  '5e' = '5e',
  '4e' = '4e',
  '3e' = '3e',
}

export interface OfficialPeriode {
  name: string;
  start: Date;
  end: Date;
}

export interface Zone {
  label: string;
  value: string;
  periodes: { [k: string]: OfficialPeriode[] };
}

export const zones: Zone[] = [
  {
    label: 'Zone A',
    value: 'Zone A',
    periodes: {
      '20202021': [
        {
          name: 'Période 1',
          start: new Date(2020, 8, 1),
          end: new Date(2020, 9, 17),
        },
        {
          name: 'Période 2',
          start: new Date(2020, 10, 2),
          end: new Date(2020, 11, 19),
        },
        {
          name: 'Période 3',
          start: new Date(2021, 0, 4),
          end: new Date(2021, 1, 6),
        },
        {
          name: 'Période 4',
          start: new Date(2021, 1, 22),
          end: new Date(2021, 3, 10),
        },
        {
          name: 'Période 5',
          start: new Date(2021, 3, 26),
          end: new Date(2021, 6, 6),
        },
      ],
    },
  },
  {
    label: 'Zone B',
    value: 'Zone B',
    periodes: {
      '20202021': [
        {
          name: 'Période 1',
          start: new Date(2020, 8, 1),
          end: new Date(2020, 9, 17),
        },
        {
          name: 'Période 2',
          start: new Date(2020, 10, 2),
          end: new Date(2020, 11, 19),
        },
        {
          name: 'Période 3',
          start: new Date(2021, 0, 4),
          end: new Date(2021, 1, 20),
        },
        {
          name: 'Période 4',
          start: new Date(2021, 2, 8),
          end: new Date(2021, 3, 24),
        },
        {
          name: 'Période 5',
          start: new Date(2021, 4, 10),
          end: new Date(2021, 6, 6),
        },
      ],
    },
  },
  {
    label: 'Zone C',
    value: 'Zone C',
    periodes: {
      '20202021': [
        {
          name: 'Période 1',
          start: new Date(2020, 8, 1),
          end: new Date(2020, 9, 17),
        },
        {
          name: 'Période 2',
          start: new Date(2020, 10, 2),
          end: new Date(2020, 11, 19),
        },
        {
          name: 'Période 3',
          start: new Date(2021, 0, 4),
          end: new Date(2021, 1, 13),
        },
        {
          name: 'Période 4',
          start: new Date(2021, 2, 1),
          end: new Date(2021, 3, 17),
        },
        {
          name: 'Période 5',
          start: new Date(2021, 4, 3),
          end: new Date(2021, 6, 6),
        },
      ],
    },
  },
];

export const allPremierDegreNiveaux = [
  {
    label: 'TPS',
    value: 'TPS',
  },
  {
    label: 'PS',
    value: 'PS',
  },
  {
    label: 'MS',
    value: 'MS',
  },
  {
    label: 'GS',
    value: 'GS',
  },
  {
    label: 'CP',
    value: 'CP',
  },
  {
    label: 'CE1',
    value: 'CE1',
  },
  {
    label: 'CE2',
    value: 'CE2',
  },
  {
    label: 'CM1',
    value: 'CM1',
  },
  {
    label: 'CM2',
    value: 'CM2',
  },
];

export const allNiveaux = [
  ...allPremierDegreNiveaux,
  {
    label: '6e',
    value: '6e',
  },
  {
    label: '5e',
    value: '5e',
  },
  {
    label: '4e',
    value: '4e',
  },
  {
    label: '3e',
    value: '3e',
  },
];

/**
 * @deprecated getNiveauxFromCycle from scholarSystem
 */
export const getNiveauxFromCycle = (cycle: string) => {
  switch (cycle) {
    case 'Cycle 1':
      return ['TPS', 'PS', 'MS', 'GS'] as Niveau[];
    case 'Cycle 2':
      return ['CP', 'CE1', 'CE2'] as Niveau[];
    case 'Cycle 3':
      return ['CM1', 'CM2', '6e'] as Niveau[];
    case 'Cycle 4':
      return ['5e', '4e', '3e'] as Niveau[];
    default:
      return ['CE1'] as Niveau[];
  }
};

export interface Classroom {
  id: string;
  idBe?: string;
  name: string;
  cycle: string[];
  degree?: string;
  workingDays: number[];
  schoolId?: string;
  tags: Tag[];
  events: CJEvent[];
  order: number;
}

export interface RestorableClassroom {
  id: string;
  schoolyearId: string;
  schoolyear: number;
  schoolId: string;
  schoolName: string;
  name: string;
  createdAt: Date;
  deletedAt: Date;
}
